import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

const componentStyles = StyleSheet.create({
  whiteRoundedLine: {
    fill: 'none',
    stroke: '#FFFFFF',
    strokeLinecap: 'round',
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
  },
});

export default class SpecialtyVehicleRVRefinanceSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.action)}
            d="M87.011,32.2H51.086l-7.077,5.722a2.464,2.464,0,0,0,.586,3.817h9.893s5.274,16.946.013,27.7H68.462c0-.045-.006-.088-.006-.132a6.987,6.987,0,1,1,13.973,0c0,.044,0,.087-.006.132h4.588a2.953,2.953,0,0,0,2.952-2.953V35.155A2.952,2.952,0,0,0,87.011,32.2ZM82.825,50.094a1.607,1.607,0,0,1-1.6,1.6H67.5a1.607,1.607,0,0,1-1.6-1.6V42.738a1.607,1.607,0,0,1,1.6-1.6H81.223a1.607,1.607,0,0,1,1.6,1.6Z"
          />
          <path
            className={css(styles.grey)}
            d="M23.881,62.868a5.576,5.576,0,1,1-5.541,5.576A5.559,5.559,0,0,1,23.881,62.868Zm54.313,6.469a2.664,2.664,0,1,0-2.663,2.68A2.672,2.672,0,0,0,78.194,69.337Zm3.1,0a5.765,5.765,0,1,1-5.764-5.8A5.783,5.783,0,0,1,81.3,69.337Zm-33.483,0a2.663,2.663,0,1,0-2.663,2.68A2.672,2.672,0,0,0,47.812,69.337Zm3.1,0a5.765,5.765,0,1,1-5.765-5.8A5.783,5.783,0,0,1,50.914,69.337Z"
          />
          <polygon
            className={css(styles.actionAccent)}
            points="48.079 50.788 27.88 50.787 17.661 57.719 37.861 57.72 48.079 50.788"
          />
          <rect className={css(styles.white)} x="17.634" y="57.637" width="20.127" height="11.893" />
          <path
            className={css(styles.actionAccent)}
            d="M35.171,60.227V66.94H20.224V60.227H35.171m2.59-2.59H17.634V69.53H37.761V57.637Z"
          />
          <rect className={css(styles.action)} x="24.717" y="67.704" width="10.432" height="1.83" />
          <rect className={css(styles.action)} x="24.717" y="64.045" width="10.432" height="1.83" />
          <rect className={css(styles.grey)} x="24.717" y="65.875" width="10.432" height="1.83" />
          <polygon
            className={css(styles.grey)}
            points="54.341 41.741 34.056 41.741 27.882 50.747 48.167 50.747 54.341 41.741"
          />
          <rect className={css(styles.actionAccent)} x="10.811" y="62.109" width="20.127" height="7.425" />
          <rect
            className={css(styles.grey)}
            x="18.08"
            y="64.863"
            width="5.604"
            height="1.753"
            rx="0.877"
            transform="translate(41.764 131.479) rotate(180)"
          />
          <line className={css(componentStyles.whiteRoundedLine)} x1="41.628" y1="52.419" x2="39.851" y2="52.419" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="36.121" y1="52.419" x2="34.343" y2="52.419" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="30.613" y1="52.419" x2="28.836" y2="52.419" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="38.692" y1="54.302" x2="36.915" y2="54.302" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="33.185" y1="54.302" x2="31.407" y2="54.302" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="27.677" y1="54.302" x2="25.9" y2="54.302" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="35.452" y1="56.428" x2="33.675" y2="56.428" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="29.945" y1="56.428" x2="28.168" y2="56.428" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="24.437" y1="56.428" x2="22.66" y2="56.428" />
          <polyline
            className={css(styles.grey)}
            points="52.746 68.624 53.058 41.738 58.16 41.738 58.16 69.479 52.693 69.479 52.636 68.624"
          />
          <rect className={css(styles.actionAccent)} x="43.96" y="28.376" width="2" height="3.847" />
          <rect className={css(styles.grey)} x="37.774" y="22.862" width="14.373" height="5.493" />
          <path
            className={css(styles.actionAccent)}
            d="M53.147,29.356H36.773V21.862H53.147Zm-14.374-2H51.147V23.862H38.773Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M54.488,41.727h-.046l-6.606,9.016L37.761,57.692V69.513h.448c-.005-.1-.016-.2-.016-.31a6.987,6.987,0,0,1,13.974,0c0,.105-.011.207-.016.31h2.337C59.772,58.761,54.488,41.727,54.488,41.727Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="68.988"
            y="45.979"
            width="11.513"
            height="1.1"
            rx="0.55"
            transform="translate(121.273 -28.216) rotate(90)"
          />
          <path
            className={css(styles.actionAccent)}
            d="M44.632,37.892l7.077-5.7H30.242l-7.078,5.7a2.24,2.24,0,0,0,1.59,3.825l19.844-.01c.35,0,1.039,0,1.042,0A2.3,2.3,0,0,1,44.632,37.892Z"
          />
        </g>
      </svg>
    );
  }
}
